/** */
export const READ_MANY_BLOGS = 'read multiple blogs.';
export const READ_ONE_BLOG = 'read one blog.';

export const ADD_ONE_BLOG_TO_STORE = 'add one blog to store.';
export const ADD_SEARCH_RESULTS_TO_STORE = 'add blog search results to store.';
export const ADD_MANY_BLOGS_TO_STORE = 'add multiple blogs to store.';
export const LOAD_BLOGS_TO_STORE = 'load up blogs to store.';
export const REM_ONE_BLOG_FROM_STORE = 'remove a blog from the store.';

/** */
export const readManyBlogs = (payload) => ({
  type: READ_MANY_BLOGS,
  payload
});

export const readOneBlog = (payload) => ({
  type: READ_ONE_BLOG,
  payload
});

export const addManyBlogsToStore = (payload) => ({
  type: ADD_MANY_BLOGS_TO_STORE,
  payload
});

export const addOneBlogToStore = (payload) => ({
  type: ADD_ONE_BLOG_TO_STORE,
  payload
});

export const addBlogSearchResultsToStore = (payload) => ({
  type: ADD_SEARCH_RESULTS_TO_STORE,
  payload
});

export const loadBlogsToStore = (payload) => ({
  type: LOAD_BLOGS_TO_STORE,
  payload
});

export const removeOneBlogFromStore = (payload) => ({
  type: REM_ONE_BLOG_FROM_STORE,
  payload
});
